import {
  BuildingInstallationReport,
  Building,
  DeliveryPoint,
  DeliveryPointInstallationReport,
  SectionStatus,
} from '../entities/installation-reporting-mdu-details.entities';

const sectionValue = (
  sectionStatuses: Record<string, SectionStatus>,
  section: string,
): string | null => {
  const value = sectionStatuses[section];
  return value?.completedDate ?? value?.status ?? null;
};

export const mapBuildingInstallationReportToBuilding = (
  building: BuildingInstallationReport,
): Building => ({
  id: building.id,
  address: building.name,
  sectionStatuses: building.sectionStatuses,
  deliveryStatus: building.deliveryStatus ?? null,
  plotDesign: sectionValue(building.sectionStatuses, 'PLOT_DESIGN'),
  preinstallation: sectionValue(building.sectionStatuses, 'PRE_INSTALLATION'),
  plotExcavation: sectionValue(building.sectionStatuses, 'PLOT_EXCAVATION'),
  ductConnection: sectionValue(building.sectionStatuses, 'DUCT_CONNECTING'),
  cableBlowing: sectionValue(building.sectionStatuses, 'CABLE_BLOWING'),
  splicingMeasuring: sectionValue(
    building.sectionStatuses,
    'SPLICING_MEASURING',
  ),
  commissioning: sectionValue(building.sectionStatuses, 'COMMISSION'),
  deliveryPoints: [],
  contactInformation: [],
  propertyInformation: [],
});

export const mapDeliveryPointInstallationReportToDeliveryPoint = (
  point: DeliveryPointInstallationReport,
): DeliveryPoint => ({
  id: point.id,
  address: point.address,
  deliveryStatus: point.deliveryStatus ?? null,
  sectionStatuses: point.sectionStatuses,
  macId: point.installationInformation?.macAddress ?? null,
  accessId: point.installationInformation?.accessId ?? null,
  installationDate: point.installationDate,
  preinstallation: sectionValue(point.sectionStatuses, 'PRE_INSTALLATION'),
  splicingMeasuring: sectionValue(point.sectionStatuses, 'SPLICING_MEASURING'),
  commissioning: sectionValue(point.sectionStatuses, 'COMMISSION'),
});
